import React from 'react'

function SpareParts() {
  return (
    <div className="container Detail">
    <h6>   Spare Parts Dealers</h6>
   <p>Here is a list of spare parts dealers in Ethiopia...</p>
    </div>
  )
}

export default SpareParts;